import { render, staticRenderFns } from "./TriggerPaymentIndex.vue?vue&type=template&id=2ac27122&scoped=true"
import script from "./TriggerPaymentIndex.vue?vue&type=script&lang=js"
export * from "./TriggerPaymentIndex.vue?vue&type=script&lang=js"
import style0 from "./TriggerPaymentIndex.vue?vue&type=style&index=0&id=2ac27122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac27122",
  null
  
)

export default component.exports